import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const RfqsTabSkeleton: React.FC = () => (
  <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-2 py-2">
      <Skeleton className="h-7 w-20" />
      <Skeleton className="h-8 w-36" />
      <Skeleton className="h-8 w-52" />
      <Skeleton className="ml-auto h-8 w-36" />
    </div>
    <div className="space-y-2 rounded-md border p-3">
      {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-9 w-full" />)}
    </div>
  </div>
)
export default RfqsTabSkeleton
